import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@leagueplatform/auth-utils";
import { LoadingIndicator } from "@leagueplatform/web-common-components";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";
import {
  ErrorState,
  ERROR_TYPES,
} from "components/error-state/error-state.component";
import { PreLoginLandingPage } from "pages/pre-login-landing/pre-login-landing.page";

// Auth0's benign "no session" response — treat as normal unauthenticated
// state so first-visit users don't see the auth-error screen.
const LOGIN_REQUIRED = "login_required";

export const LandingRoute = () => {
  const { isAuthenticated } = useAuth({ redirectToLogInWhenSignedOut: false });
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const errorType = params.get("error");

  if (isAuthenticated === undefined) return <LoadingIndicator />;
  if (isAuthenticated) return <Navigate to={APP_MANAGED_ROUTES.HOME} replace />;

  if (errorType && errorType !== LOGIN_REQUIRED) {
    return (
      <ErrorState
        error={null}
        isFullPage
        errorType={ERROR_TYPES.AUTH_ERROR}
        buttonAction={() =>
          navigate(APP_MANAGED_ROUTES.LANDING_PAGE, { replace: true })
        }
      />
    );
  }

  return <PreLoginLandingPage />;
};
